import { polyfillChromeAI } from './session';

polyfillChromeAI(globalThis.__polyfill_ai_options__);
